// Enhanced Lightbox Fix mit Navigation für Mahamudra Holders Website

(function () {
  'use strict';

  // Globale Variablen für Navigation
  window.currentImageIndex = 0;
  window.galleryImages = [];

  // Warten bis DOM geladen ist
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEnhancedLightbox);
  } else {
    initEnhancedLightbox();
  }

  function initEnhancedLightbox() {
    // Enhanced Lightbox HTML erstellen
    createEnhancedLightboxHTML();

    // Gallery Links finden und konfigurieren
    setupGalleryLinksWithNavigation();

    // Tastatur-Navigation einrichten
    setupKeyboardNavigation();
  }

  function createEnhancedLightboxHTML() {
    // Entferne existierende Lightbox falls vorhanden
    const existingLightbox = document.getElementById('custom-lightbox');
    if (existingLightbox) {
      existingLightbox.remove();
    }

    // Enhanced Lightbox HTML mit Navigation
    const lightboxHTML = `
            <div id="custom-lightbox" style="
                display: none;
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(0,0,0,0.8);
                z-index: 9999;
                cursor: pointer;
            ">
                <div style="
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    max-width: 90%;
                    max-height: 85vh;
                    width: auto;
                    height: auto;
                ">
                    <img id="lightbox-image" style="
                        max-width: 100%;
                        max-height: 80vh;
                        width: auto;
                        height: auto;
                        object-fit: contain;
                        display: block;
                    ">
                    <div id="lightbox-title" style="
                        color: white;
                        text-align: center;
                        padding: 10px;
                        font-size: 16px;
                        font-family: Arial, sans-serif;
                    "></div>
                    <div id="lightbox-counter" style="
                        color: white;
                        text-align: center;
                        padding: 5px;
                        font-size: 14px;
                        font-family: Arial, sans-serif;
                        opacity: 0.8;
                    "></div>
                </div>
                
                <!-- Schließen Button -->
                <div id="lightbox-close" style="
                    position: absolute;
                    top: 20px;
                    right: 30px;
                    color: white;
                    font-size: 30px;
                    cursor: pointer;
                    font-family: Arial, sans-serif;
                    font-weight: bold;
                    line-height: 1;
                    user-select: none;
                ">
                    ×
                </div>
                
                <!-- Vorheriges Bild Button -->
                <div id="lightbox-prev" style="
                    position: absolute;
                    left: 30px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: white;
                    font-size: 40px;
                    cursor: pointer;
                    font-family: Arial, sans-serif;
                    font-weight: bold;
                    user-select: none;
                    opacity: 0.7;
                    transition: opacity 0.3s;
                ">
                    ‹
                </div>
                
                <!-- Nächstes Bild Button -->
                <div id="lightbox-next" style="
                    position: absolute;
                    right: 30px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: white;
                    font-size: 40px;
                    cursor: pointer;
                    font-family: Arial, sans-serif;
                    font-weight: bold;
                    user-select: none;
                    opacity: 0.7;
                    transition: opacity 0.3s;
                ">
                    ›
                </div>
            </div>
        `;

    document.body.insertAdjacentHTML('beforeend', lightboxHTML);

    // Event Listeners hinzufügen
    setupLightboxEventListeners();
  }

  function setupLightboxEventListeners() {
    const lightbox = document.getElementById('custom-lightbox');
    const closeBtn = document.getElementById('lightbox-close');
    const prevBtn = document.getElementById('lightbox-prev');
    const nextBtn = document.getElementById('lightbox-next');

    // Lightbox schließen bei Klick auf Hintergrund
    lightbox.addEventListener('click', function (e) {
      if (e.target === this) {
        closeLightbox();
      }
    });

    // Schließen Button
    closeBtn.addEventListener('click', closeLightbox);

    // Navigation Buttons
    prevBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      previousImage();
    });

    nextBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      nextImage();
    });

    // Hover-Effekte für Navigation
    [prevBtn, nextBtn].forEach((btn) => {
      btn.addEventListener('mouseenter', function () {
        if (this.style.cursor !== 'default') {
          this.style.opacity = '1';
        }
      });
      btn.addEventListener('mouseleave', function () {
        if (this.style.cursor !== 'default') {
          this.style.opacity = '0.7';
        }
      });
    });
  }

  function setupGalleryLinksWithNavigation() {
    // Alle Bild-Links finden
    const galleryLinks = document.querySelectorAll(
      'a[href*=".jpg"], a[href*=".png"], a[href*=".jpeg"], a[href*=".webp"]',
    );

    // Gallery Images Array erstellen
    window.galleryImages = Array.from(galleryLinks).map((link, index) => {
      const thumbImg = link.querySelector('img');
      return {
        src: link.href,
        thumb: thumbImg ? (thumbImg.currentSrc || thumbImg.src) : null,
        title: `Milarepa Image ${index + 1}`,
        element: link,
      };
    });

    // Event Handlers für alle Links
    galleryLinks.forEach((link, index) => {
      link.setAttribute('data-lightbox', 'milarepa-gallery');
      link.setAttribute('data-title', `Milarepa Image ${index + 1}`);

      link.addEventListener('click', function (e) {
        e.preventDefault();
        window.currentImageIndex = index;
        openLightboxWithNavigation();
      });
    });

    console.log(
      `Enhanced lightbox setup complete for ${window.galleryImages.length} images`,
    );
  }

  function setupKeyboardNavigation() {
    document.addEventListener('keydown', function (e) {
      const lightbox = document.getElementById('custom-lightbox');
      if (lightbox && lightbox.style.display === 'block') {
        switch (e.key) {
          case 'Escape':
            closeLightbox();
            break;
          case 'ArrowLeft':
            previousImage();
            break;
          case 'ArrowRight':
            nextImage();
            break;
        }
        e.preventDefault();
      }
    });
  }

  // Globale Funktionen für Lightbox-Steuerung
  function openLightboxWithNavigation() {
    const lightbox = document.getElementById('custom-lightbox');
    const image = document.getElementById('lightbox-image');
    const titleElement = document.getElementById('lightbox-title');
    const counterElement = document.getElementById('lightbox-counter');

    if (
      lightbox && image && titleElement && counterElement &&
      window.galleryImages[window.currentImageIndex]
    ) {
      const currentImage = window.galleryImages[window.currentImageIndex];

      setLightboxImage(image, currentImage);
      titleElement.textContent = currentImage.title;
      counterElement.textContent = `${
        window.currentImageIndex + 1
      } / ${window.galleryImages.length}`;

      lightbox.style.display = 'block';
      document.body.style.overflow = 'hidden';

      updateNavigationButtons();
      preloadNeighbors();
    }
  }

  // Show the small thumbnail (already page-cached) instantly as a blurred
  // placeholder, then swap to the full-res image once it has loaded. The
  // index guard prevents a slow full-res load from overwriting a newer image
  // when the user clicks through quickly.
  function setLightboxImage(image, currentImage) {
    if (currentImage.thumb) {
      image.src = currentImage.thumb;
      image.style.filter = 'blur(8px)';
    } else {
      image.style.filter = '';
    }
    const full = new Image();
    full.onload = function () {
      const active = window.galleryImages[window.currentImageIndex];
      if (active && active.src === currentImage.src) {
        image.src = currentImage.src;
        image.style.filter = '';
      }
    };
    full.src = currentImage.src;
  }

  // Warm next + previous full-res images into the browser cache so
  // clicking through the gallery shows them instantly instead of after a fetch.
  function preloadNeighbors() {
    [window.currentImageIndex + 1, window.currentImageIndex - 1].forEach(
      (i) => {
        const neighbor = window.galleryImages[i];
        if (neighbor) {
          const img = new Image();
          img.src = neighbor.src;
        }
      },
    );
  }

  function nextImage() {
    if (window.currentImageIndex < window.galleryImages.length - 1) {
      window.currentImageIndex++;
      updateLightboxDisplay();
    }
  }

  function previousImage() {
    if (window.currentImageIndex > 0) {
      window.currentImageIndex--;
      updateLightboxDisplay();
    }
  }

  function closeLightbox() {
    const lightbox = document.getElementById('custom-lightbox');
    if (lightbox) {
      lightbox.style.display = 'none';
      document.body.style.overflow = '';
    }
  }

  function updateLightboxDisplay() {
    const image = document.getElementById('lightbox-image');
    const titleElement = document.getElementById('lightbox-title');
    const counterElement = document.getElementById('lightbox-counter');

    if (
      image && titleElement && counterElement &&
      window.galleryImages[window.currentImageIndex]
    ) {
      const currentImage = window.galleryImages[window.currentImageIndex];

      setLightboxImage(image, currentImage);
      titleElement.textContent = currentImage.title;
      counterElement.textContent = `${
        window.currentImageIndex + 1
      } / ${window.galleryImages.length}`;

      updateNavigationButtons();
      preloadNeighbors();
    }
  }

  function updateNavigationButtons() {
    const prevBtn = document.getElementById('lightbox-prev');
    const nextBtn = document.getElementById('lightbox-next');

    if (prevBtn && nextBtn) {
      // Vorheriges Button
      if (window.currentImageIndex === 0) {
        prevBtn.style.opacity = '0.3';
        prevBtn.style.cursor = 'default';
      } else {
        prevBtn.style.opacity = '0.7';
        prevBtn.style.cursor = 'pointer';
      }

      // Nächstes Button
      if (window.currentImageIndex === window.galleryImages.length - 1) {
        nextBtn.style.opacity = '0.3';
        nextBtn.style.cursor = 'default';
      } else {
        nextBtn.style.opacity = '0.7';
        nextBtn.style.cursor = 'pointer';
      }
    }
  }
})();
